import { useEffect, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { http } from "./api";
import "@/App.css";
import Login from "./pages/Login";
import Apply from "./pages/Apply";
import AppShell from "./components/AppShell";
import ClientMarketplace from "./pages/ClientMarketplace";
import Shortlist from "./pages/Shortlist";
import Orders from "./pages/Orders";
import ArtistDashboard from "./pages/ArtistDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import PitchPage from "./pages/PitchPage";
import ArtistPitchPage from "./pages/ArtistPitchPage";
import CreatorJourney from "./pages/CreatorJourney";
import CreatorAuthCallback from "./pages/CreatorAuthCallback";

const DEFAULT_PAGE = { admin: "dashboard", artist: "dashboard", client: "marketplace", creator: "journey" };

function App() {
  const location = useLocation();
  const { pathname } = location;
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const [page, setPage] = useState("");

  useEffect(() => {
    // Returning from Google sign-in: CreatorAuthCallback exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) { setChecking(false); return; }
    http.get("/auth/me").then(r => { setUser(r.data); setPage(DEFAULT_PAGE[r.data.role] || "marketplace"); })
      .catch(() => {})
      .finally(() => setChecking(false));
  }, []);

  const handleAuth = (data) => { setUser(data); setPage(DEFAULT_PAGE[data.role] || "marketplace"); if (pathname === "/admin") window.history.replaceState(null, "", "/"); };
  const logout = async () => { await http.post("/auth/logout"); setUser(null); setPage(""); };

  if (location.hash?.includes("session_id=")) return <CreatorAuthCallback onAuth={handleAuth} />;
  if (pathname === "/apply") return <Apply />;
  if (pathname.startsWith("/voices/")) return <PitchPage token={pathname.split("/").filter(Boolean)[1]} />;
  if (pathname.startsWith("/artist-voices/")) return <ArtistPitchPage token={pathname.split("/").filter(Boolean)[1]} />;
  if (checking) return <div className="loading">Loading workroom…</div>;
  if (!user) return <Login onAuth={handleAuth} adminMode={pathname === "/admin"} creatorMode={pathname === "/creator"} />;

  return (
    <AppShell user={user} page={page} setPage={setPage} onLogout={logout}>
      {user.role === "admin" && <AdminDashboard page={page} setPage={setPage} user={user} />}
      {user.role === "artist" && <ArtistDashboard page={page} />}
      {user.role === "creator" && <CreatorJourney user={user} />}
      {user.role === "client" && page === "marketplace" && <ClientMarketplace user={user} />}
      {user.role === "client" && page === "shortlist" && <Shortlist />}
      {(user.role === "client" || user.role === "artist" || user.role === "admin") && page === "orders" && <Orders user={user} />}
    </AppShell>
  );
}

export default function Wrapped() {
  return <BrowserRouter><App /></BrowserRouter>;
}
